var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRouterAlive)?_c('div',{staticClass:"grid grid-cols-1",attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }